export default __webpack_public_path__ + "static/media/can-not-do.93c5f533.png";